import angular = require("angular");
import TPL = require("templates");

/**
  Circular image with colored border and elevation
  params:
  dark: boolean to get a darker border, optimized for white bg
  image: {
    src: link to an image,
    size: shortcut to assing default dimensions, it accept 'xs', 'sm', 'md' or 'lg', default: 'md'
    class: string, additional classes to assign to the img object
  }
  label: {
    text: the text of the label
    position: te position relative to the image, can be 'top', 'bottom', 'left' or 'right', default: 'bottom'
    class: string additional classes to assign to the text object
  }
*/
export class AvatarDirective {

  template = TPL.commonDirectives.avatar;
  scope = {
    params: "=params"
  };
  link;

  constructor() {
    this.link = (scope, el, attrs) => {
        var randomColor = this.getRandomColor();

        scope.vm = {
          getUserInitials: () => {
            if ((!scope.vm.hasImage() || !scope.params.image.src) && scope.params.initials != null) {
              if(scope.params.initials.first_name != null && scope.params.initials.last_name != null) {
                  return scope.params.initials.first_name.charAt(0) + scope.params.initials.last_name.charAt(0);
              } else {
                  return "";
              }
            } else {
              return ""
            }
          },

          getAvatarAdditionalClass: () => {
            var result = "";
            if (!scope.params) {return result;}

            if (!!scope.params.dark) {
              result += "ot-dark ";
            }

            if (scope.vm.isHorizontal()) {
              result += "ot-horizontal ";
            }

            if (scope.vm.isVertical()) {
              result += "ot-vertical ";
            }

            return result;
          },

          //image stuff
          hasImage: () => {
            return scope.params &&
                   scope.params.image;
          },
          getImageSize: () => {
            if (!scope.vm.hasImage()){ return "md";}

            switch(scope.params.image.size) {
              case "xs":
                return "xs";
              case "ss":
                return "ss";
              case "sm":
                return "sm";
              case "lg":
                return "lg";
              case "md":
              default:
                return "md";
            }
          },

          getRandomIndex: (length) => {
              return Math.floor(Math.random() * length);
          },

          getImageStyle: () : any => {
            if (!scope.vm.hasImage() || !scope.params.image.src) {
              return {'background': randomColor, 'align-content':'center', 'display':'flex'};
            } else {
              return {'background-image':'url(' + scope.params.image.src + ')'};
            }
          },
          getImageClass: () => {
            if (!scope.vm.hasImage()){ return "";}

            return "ot-" + scope.vm.getImageSize();
          },
          getImageAdditionalClass: () => {
            if (!scope.vm.hasImage()){ return "";}

            return scope.params.image.class;
          },

          //label stuff
          hasLabel: () => {
            return scope.params &&
                   scope.params.label &&
                   scope.params.label.text &&
                   scope.params.label.text.length > 0;
          },
          hasLabelPrefix: () => {
            return scope.params &&
                   scope.params.label &&
                   scope.params.label.prefix &&
                   scope.params.label.prefix.length > 0;
          },
          hasLabelSuffix: () => {
            return scope.params &&
                   scope.params.label &&
                   scope.params.label.suffix &&
                   scope.params.label.suffix.length > 0;
          },
          isHorizontal: () => {
            var pos = scope.vm.getLabelPosition();
            return scope.vm.hasLabel() && (pos == "left" || pos == "right");
          },
          isVertical: () => {
            var pos = scope.vm.getLabelPosition();
            return scope.vm.hasLabel() && (pos == "top" || pos == "bottom");
          },
          hasLabelBefore: () => {
            var pos = scope.vm.getLabelPosition();
            return scope.vm.hasLabel() && (pos == "top" || pos == "left");
          },
          hasLabelAfter: () => {
            var pos = scope.vm.getLabelPosition();
            return scope.vm.hasLabel() && (pos == "right" || pos == "bottom");
          },
          getLabelText: () => {
            if (!scope.vm.hasLabel()){ return "";}

            return scope.params.label.text;
          },
          getLabelPrefix: () => {
            if (!scope.vm.hasLabelPrefix()){ return "";}

            return scope.params.label.prefix;
          },
          getLabelSuffix: () => {
            if (!scope.vm.hasLabelSuffix()){ return "";}

            return scope.params.label.suffix;
          },
          getLabelPosition: () => {
            if (!scope.vm.hasLabel()){ return "bottom";}

            switch(scope.params.label.position) {
              case "left":
                return "left";
              case "right":
                return "right";
              case "top":
                return "top";
              case "bottom":
              default:
                return "bottom";
            }
          },
          getLabelClass: () => {
            //if (scope.vm.params.type != 'manage') {
              if (!scope.vm.hasLabel()){ return "";}

              return "ot-" + scope.vm.getLabelPosition();
            //}
          },
          getLabelAdditionalClass: () => {
            if (!scope.vm.hasLabel()){ return "";}

            return scope.params.label.class;
          }
        };
    }
  }

  static factory() {
    return () => new AvatarDirective();
  }

  getRandomColor() {
    var colors = ["#8D1B3D", "#443135", "#857363", "#50C9B5", "#FCD450"];
    var randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/avatar.ts
 **/